var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    {
      staticClass: "supsis-plan",
      class: {
        "selected-plan":
          !_vm.editableCard &&
          _vm.isActive(_vm.plan, _vm.currentPlansHash[_vm.plan._id]),
        "supsis-plan": true,
      },
    },
    [
      _vm.editableCard
        ? _c("div", { staticClass: "editable-form" }, [
            _c(
              "div",
              { staticClass: "form-button", on: { click: _vm.editPlan } },
              [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v(" edit "),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-button delete-button",
                on: { click: _vm.deletePlan },
              },
              [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v(" delete "),
                ]),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "p-card-header" }, [
        _c("div", [
          _c(
            "div",
            {
              staticClass: "subtitle top",
              class: { setFont: _vm.plan.isPopular },
            },
            [
              _vm._v(
                "\n                " + _vm._s(_vm.plan.title) + "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.plan.altTitle)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "subtitle price setFontPrice" }, [
            _c("div", [
              _vm._v(
                _vm._s(_vm.getPrice(_vm.plan, _vm.details, _vm.period)) + "₺"
              ),
            ]),
            _vm._v(" "),
            _c("div", [
              _vm.getDiscount(_vm.plan) >
              _vm.getPrice(_vm.plan, _vm.details, _vm.period)
                ? _c("div", { staticClass: "discount" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.getDiscount(_vm.plan)) +
                        "₺\n                    "
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "p-card-tag" }, [
          _vm.plan.isPopular &&
          !_vm.isActive(_vm.plan, _vm.currentPlansHash[_vm.plan._id])
            ? _c("div", { staticClass: "popular" }, [_vm._v("Popüler")])
            : (
                _vm.wizard
                  ? _vm.isSelected
                  : !_vm.editableCard &&
                    _vm.isActive(_vm.plan, _vm.currentPlansHash[_vm.plan._id])
              )
            ? _c("div", { staticClass: "selected-plan-tag" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.isSelected ? "Seçildi" : "Mevcut Plan") +
                    "\n            "
                ),
              ])
            : _vm.plan.isTrialPlan
            ? _c("div", { staticClass: "popular" }, [_vm._v("Deneme Paketi")])
            : _vm.editableCard
            ? _c("div", { staticClass: "popular" }, [
                _vm._v(_vm._s(_vm.plan.siteId ? "Özel Plan" : "Genel Plan")),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "p-card-content" }, [
        _vm.plan.features
          ? _c(
              "div",
              _vm._l(Object.keys(_vm.features), function (key) {
                return _c(
                  "p",
                  { key: key },
                  [
                    _c("i", { staticClass: "fa fa-check" }),
                    _vm._v(" "),
                    key === _vm.Features.AGENT.FREE_AGENT_COUNT
                      ? [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.features[key]) +
                              " Ücretsiz Temsilci\n                "
                          ),
                        ]
                      : key === _vm.Features.AGENT.AGENT_COUNT
                      ? [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.features[key] < 0
                                  ? "Sınırsız"
                                  : _vm.features[key]
                              ) +
                              " Temsilci\n                "
                          ),
                        ]
                      : key === _vm.Features.CHATBOT.MAX_SESSION_COUNT
                      ? [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.features[key] < 0
                                  ? "Sınırsız"
                                  : _vm.features[key]
                              ) +
                              "\n                    Chatbot\n                "
                          ),
                        ]
                      : key === _vm.Features.CHATBOT.INTEGRATION_COUNT
                      ? [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.features[key] < 0
                                  ? "Sınırsız"
                                  : _vm.features[key]
                              ) +
                              " Chatbot Entegrasyon\n                "
                          ),
                        ]
                      : key === _vm.Features.CHATBOT.STORY_COUNT_LIMIT
                      ? [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.features[key] < 0
                                  ? "Sınırsız"
                                  : _vm.features[key]
                              ) +
                              " Chatbot Hikaye\n                "
                          ),
                        ]
                      : key === _vm.Features.CHATBOT.VERSION_HISTORY_COUNT
                      ? [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.features[key] < 0
                                  ? "Sınırsız"
                                  : _vm.features[key]
                              ) +
                              " Chatbot Sürüm Geçmişi\n                "
                          ),
                        ]
                      : key === _vm.Features.CHAT.AUTO_TRANSLATION
                      ? [_vm._v(" Otomatik Çeviri")]
                      : key === _vm.Features.CHAT.VOICE_CALLING
                      ? [_vm._v("Sesli Arama")]
                      : key === _vm.Features.CHAT.VIDEO_CALLING
                      ? [_vm._v("Görüntülü Arama")]
                      : key === _vm.Features.SYSTEM.DATA_PROTECT
                      ? [_vm._v(" Veri Güvenliği")]
                      : key === _vm.Features.SYSTEM.ACCESS_ALL_AGENT
                      ? [
                          _vm._v(
                            "\n                    Tüm Temsilciler için Erişim\n                "
                          ),
                        ]
                      : key === _vm.Features.WHATSAPP.NOT_ADDITIONAL_PRICE
                      ? [
                          _vm._v(
                            "\n                    Ek Maliyet Gerektirmez\n                "
                          ),
                        ]
                      : key === _vm.Features.REPORT.REPORT
                      ? [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.features[key] === "basic-report"
                                  ? "Normal Raporlama"
                                  : "Detaylı Raporlama"
                              ) +
                              "\n                "
                          ),
                        ]
                      : key === _vm.Features.REPORT.VISITOR_TRACKING
                      ? [_vm._v("Anlık Ziyaretci Takibi")]
                      : key === _vm.Features.CHAT.FILE_AND_VOICE_MESSAGE
                      ? [
                          _vm._v(
                            "Dosya ve Ses Kaydı Paylaşımı\n                "
                          ),
                        ]
                      : key === _vm.Features.SYSTEM.TEAM_CHAT_ENTEGRATION
                      ? [
                          _vm._v(
                            "Takım Konuşması Entegrasyonu\n                "
                          ),
                        ]
                      : key === _vm.Features.SUPPORT.SUPPORT
                      ? [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.features[key] === "basic-support"
                                  ? "Standart Destek"
                                  : "7/24 Destek"
                              ) +
                              "\n                "
                          ),
                        ]
                      : key === _vm.Features.SUPPORT.SOFTWARE_SUPPORT
                      ? [_vm._v("Yazılım Desteği")]
                      : key === _vm.Features.SUPPORT.DEDICATED_CUSTOMER_SUPPORT
                      ? [_vm._v("Özel Müşteri Desteği\n                ")]
                      : key === _vm.Features.SYSTEM.CHAT_AND_NOTIFICATION
                      ? [_vm._v("Chat ve Bildirimler")]
                      : key === _vm.Features.SYSTEM.CHAT_BALLOON_CUSTOMIZATION
                      ? [_vm._v("Sohbet Balonu Özeleştirme\n                ")]
                      : key === _vm.Features.SYSTEM.REMOVE_SUPSIS_LOGO
                      ? [_vm._v(" Supsis Logo Kaldırma")]
                      : key === _vm.Features.SYSTEM.DATABASE_CONNECTION
                      ? [
                          _vm._v(
                            "\n                    İzole Veritabanı Bağlantısı\n                "
                          ),
                        ]
                      : key === _vm.Features.SYSTEM.SINGLE_PANEL_ACCESS
                      ? [_vm._v(" Tek Panelden Yönetim")]
                      : key === _vm.Features.SYSTEM.MAX_DISK_SIZE
                      ? [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.features[key] < 0
                                  ? "Sınırsız"
                                  : _vm.features[key] / 1024 / 1024 / 1024 +
                                      "GB"
                              ) +
                              " Depolama\n                "
                          ),
                        ]
                      : key === _vm.Features.SYSTEM.TICKET_SYSTEM
                      ? [_vm._v("Ticket Sistemi")]
                      : key === _vm.Features.SYSTEM.WHATSAPP_ENTEGRATION
                      ? [
                          _vm._v(
                            "\n                    Whatsapp Entegrasyonu\n                "
                          ),
                        ]
                      : key === _vm.Features.SYSTEM.INSTAGRAM_ENTEGRATION
                      ? [
                          _vm._v(
                            "\n                    Instagram Entegrasyonu\n                "
                          ),
                        ]
                      : key === _vm.Features.SYSTEM.MESSENGER_ENTEGRATION
                      ? [
                          _vm._v(
                            "\n                    Messenger Entegrasyonu\n                "
                          ),
                        ]
                      : key === _vm.Features.SYSTEM.TELEGRAM_ENTEGRATION
                      ? [
                          _vm._v(
                            "\n                    Telegram Entegrasyonu\n                "
                          ),
                        ]
                      : key === _vm.Features.TRIGGERS.MAX_TRIGGER_COUNT
                      ? [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.features[key] < 0
                                  ? "Sınırsız"
                                  : _vm.features[key]
                              ) +
                              "\n                    Akıllı Tetikleyici\n                "
                          ),
                        ]
                      : key === _vm.Features.WHATSAPP.BROADCAST_PER_MESSAGE
                      ? [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.features[key] < 0
                                  ? "Mesaj Başına Ek Ücret"
                                  : _vm.features[key] + "₺ Toplu Mesaj Başına"
                              ) +
                              "\n                "
                          ),
                        ]
                      : key === _vm.Features.WHATSAPP.BULK_MESSAGE_SENDING
                      ? [_vm._v("Toplu Mesaj Gönderme\n                ")]
                      : key ===
                        _vm.Features.WHATSAPP.MESSAGE_UNREGISTERED_NUMBERS
                      ? [
                          _vm._v(
                            "\n                    Kayıtlı Olmayan Numaralara Mesajlaşma\n                "
                          ),
                        ]
                      : key ===
                        _vm.Features.WHATSAPP.PERSONALIZED_BROADCAST_MESSAGE
                      ? [
                          _vm._v(
                            "\n                    Kişiselleştirilmiş Yayın Mesajı\n                "
                          ),
                        ]
                      : key === _vm.Features.CHATBOT.CHATBOT_BUTTON_ACTIVITY
                      ? [_vm._v("Otomatik Düğme / Chatbot\n                ")]
                      : key === _vm.Features.SYSTEM.CHATBOT_ENTEGRATION
                      ? [_vm._v("Chatbot Entegrasyonu")]
                      : key === _vm.Features.WHATSAPP.CONTROL_WHATSAPP
                      ? [_vm._v("Whatsapp Yönetimi")]
                      : key === _vm.Features.SYSTEM.VISITOR_START_CHAT
                      ? [_vm._v("Ziyaretci Chat Başlatma")]
                      : key === _vm.Features.SYSTEM.MAIL_ENTEGRATION
                      ? [_vm._v("Mail Entegrasyonu")]
                      : key === _vm.Features.SYSTEM.SMS_ENTEGRATION
                      ? [_vm._v("SMS Entegrasyonu")]
                      : key === _vm.Features.ARCHIVE.CHAT_ARCHIVE_TIME
                      ? [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.features[key] < 0
                                  ? "Sınırsız"
                                  : _vm.features[key] / 7 + " Hafta"
                              ) +
                              " Arşiv\n                "
                          ),
                        ]
                      : key === _vm.Features.CHATBOT.ACTIVE_CHATBOT_LIMIT
                      ? [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.features[key] < 0
                                  ? "Sınırsız"
                                  : "" + _vm.features[key]
                              ) +
                              " Aktif ChatBot\n                "
                          ),
                        ]
                      : key === _vm.Features.SYSTEM.READY_CONTENTS
                      ? [_vm._v(" Hazır İçerikler")]
                      : key === _vm.Features.SYSTEM.ALL_ENTEGRATION
                      ? [_vm._v("Tüm Entegrasyonlar")]
                      : key === _vm.Features.SYSTEM.WEBHOOK_ENTEGRATION
                      ? [_vm._v(" WebHook Entegrasyonu")]
                      : key === _vm.Features.SYSTEM.CALENDER_ENTEGRATION
                      ? [_vm._v(" Takvim Entegrasyonu")]
                      : key === _vm.Features.SYSTEM.TASK_MANAGEMENT_ENTEGRATION
                      ? [_vm._v(" Task Yönetimi")]
                      : key === _vm.Features.SYSTEM.AUTO_REZERVATION
                      ? [_vm._v(" Otomatik Rezervasyon")]
                      : key === _vm.Features.SYSTEM.FLEXIBLE_BILLING
                      ? [_vm._v(" Esnek Faturalandırma")]
                      : key === _vm.Features.CHAT.COPILOT
                      ? [_vm._v(" Yapay Zekalı Asistan")]
                      : key === _vm.Features.REPORT.SPECIAL_REPORT
                      ? [_vm._v(" Özel Raporlama")]
                      : key === _vm.Features.SYSTEM.PERMISSION_CONTROL
                      ? [_vm._v(" Yetkilendirme Özelliği")]
                      : key === _vm.Features.WHATSAPP.CHANNEL_COUNT
                      ? [
                          _vm._v(
                            "\n                    " +
                              _vm._s("" + _vm.features[key]) +
                              " Whatsapp Kanalı\n                "
                          ),
                        ]
                      : key === _vm.Features.WHATSAPP.BUSINESS_CHANNEL_COUNT
                      ? [
                          _vm._v(
                            "\n                    " +
                              _vm._s("" + _vm.features[key]) +
                              " Whatsapp Business Kanalı\n                "
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              }),
              0
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      !_vm.isRequireCodes() && !_vm.editableCard
        ? _c(
            "div",
            {
              staticClass: "subscription-button",
              class: {
                disabled: !_vm.isUpgrade().enabled,
                selected: _vm.isActive(),
              },
              on: { click: _vm.onClick },
            },
            [_vm._v("\n        " + _vm._s(this.getButtonText()) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isAdmin && _vm.isRequireCodes() && !_vm.editableCard
        ? _c("CodeInput", {
            attrs: { disabled: _vm.isDisabledCode() },
            on: { confirm: _vm.applyCouponCode },
            model: {
              value: _vm.couponCode,
              callback: function ($$v) {
                _vm.couponCode = $$v
              },
              expression: "couponCode",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }